import { Injectable } from '@angular/core';
import { Http, Response,ResponseContentType } from '@angular/http';
import { AuthHttp } from 'angular2-jwt';

@Injectable()
export class OrderService {

  constructor(private authHttp: AuthHttp) { }

  addItemsToCurrentOrder(order: any) {
    return this.authHttp.post("/api/order/", order).map(res => res.json());
  }

  startNewOrder(order:any){
    return this.authHttp.post("/api/order/startneworder",order).map(res => res.json());

  }

  getAllOrders(onlyOpen:boolean){
    return this.authHttp.get("/api/order/allWithTotals/"+onlyOpen).map(res => res.json())
  }

  getAllCartItems(orderId: number){
    return this.authHttp.get("/api/order/items/"+orderId).map(res => res.json())
  }

  getAllCartItemsByCartId(cartId: string){
    return this.authHttp.get("/api/order/itemsByCart/"+cartId).map(res => res.json())
  }

  getCartItemsById(id: number){
    return this.authHttp.get("/api/order/itemsById/"+id).map(res => {
      return { 'status': res.status, 'value':res.json() }
    });
  }

  deleteCartByID(cartId: string){
    return this.authHttp.delete("/api/order/"+cartId).map(res => {
      console.log("In deltecart: ");
      console.log(res);
      
      return { 'status': res.status, 'value':res.json() }
    });
  }
  
  updatePayed(memberid: number, cartId: string, payed: boolean){
    return this.authHttp.put("/api/order/payed/"+memberid+"/"+cartId+"/"+payed,null).map(res => {
      return { 'status': res.status, 'value':res.json() }
    })
  }

  changeOrderStatus(id: number, status: boolean){
    return this.authHttp.post("/api/order/changeorderstatus/"+id+"/"+status,null).map(res => {
      return { 'status': res.status, 'value':res.json() }
    })
  }

  getCurrentopenOrder(){
    return this.authHttp.get("/api/order/current").map( res =>{
      return { 'status': res.status, 'value':res.json()}
    })
  }

  changCartItem(order:any){
    return this.authHttp.put("/api/order/edit", order).map( res =>{
      return {'status': res.status, 'value':res.json() }
    } )
  }

  getCartItemsForMemberIdAndYear(memberId: number, year:number){
    return this.authHttp.get("/api/order/member/"+memberId+"/year/"+year).map ( res =>{
      return { 'status': res.status, 'value':res.json()}
    })
  }

  getOrderYearsForMember(memberId: number){
    return this.authHttp.get("/api/order/orderyears/member/"+memberId).map ( res =>{
      return { 'status': res.status, 'value':res.json()}
    })
  }

  getDiscountLeftForId(memberId: number){
    return this.authHttp.get("/api/order/getdiscountleft/"+memberId).map( res =>{
      return {'status': res.status, 'value':res.json()}
    })
  }

  downloadOrderPerMembersXlsx(orderid: number, gender: string){
    return this.authHttp.get('/api/order/generateOrderPerMemberXlsx/'+orderid+"/"+gender, { responseType: ResponseContentType.Blob }).map((res: Response) => {
      return res;
    });
  }

  downloadOrderPerMembersXlsxSheet(orderid: number, gender: string){
    return this.authHttp.get('/api/order/generateOrderPerMemberPerSheet/'+orderid+"/"+gender, { responseType: ResponseContentType.Blob }).map((res: Response) => {
      return res;
    });
  }

  getOrderOverview(orderid: number){
    return this.authHttp.get("/api/order/OrderTotalsOverview/"+orderid).map( res =>{
      return {'status': res.status, 'value':res.json()}
    })
  }

  downloadOrderOverviewXlsx(orderid: number, gender: string){
    return this.authHttp.get('/api/order/generateOrderXlsx/'+orderid+"/"+gender, { responseType: ResponseContentType.Blob }).map((res: Response) => {
      return res;
    });
  }
  
  downloadOrderListXlsx(orderid: number){
    return this.authHttp.get('/api/order/generateOrderListXlsx/'+orderid, { responseType: ResponseContentType.Blob }).map((res: Response) => {
      return res;
    });
  }

  downloadVermarcItemListXlsx(orderid: number){
    return this.authHttp.get('/api/order/generateVermarcItemListXlsx/'+orderid, { responseType: ResponseContentType.Blob }).map((res: Response) => {
      return res;
    });
  }


}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/Services/order.service.ts